import {
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  Theme,
  WithStyles,
  withStyles,
  Divider,
  Button,
  DialogActions,
  Card,
  CardHeader,
  Fab,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import TableComponent from "../components/TableComponent";
import { ADMINISTRATOR_COLUMNS } from "../constants/tableColumns";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddingUsersDialog from "./AddUsersDialog";
import { EventEmitter } from "../events/EventEmitter";
import { AuthenticationService } from "../services/AuthenticationService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import GenericDialog from "./GenericDialog";
import { isEmpty } from "../constants/constants";
import { AppContext, AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import HasMutablePermission from "../auth/HasMutablePermission";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_INPUT: "DIALOG_INPUT",
  DIALOG_ACTION: "DIALOG_ACTION",
  DIALOG_ERROR: "DIALOG_ERROR",
};
export const MODE_TYPE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
const styles = (theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
  });
const createUniqueIdentifier = function (row: any, index: any) {
  return `${row._id}`;
};
const createData = function (row: any) {
  return {
    fullName: row.fullName,
    email: row.email,
    employeeNumber: row.employeeNumber,
    phone: row.phone,
    role: row.role,
  };
};
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  mode: any;
  companyData?: any;
  handleClose: any;
  handleOnSubmit: any;
}
class ManageUsersDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    sameAsAbove: false,
    hasError: false,
    data: [],
    openAddUsersDialog: false,
    openConfirmationDialog: false,
    openEmployeeLoginDetailsDialog: false,
    editData: {},
    selectedRow: { fullName: "" },
    recentlyAddedUser: {
      fullName: "",
      employeeNumber: "",
      password: "",
      role: "",
      email: "",
    },
    editedUser: {
      fullName: "",
      employeeNumber: "",
      password: "",
      role: "",
      email: "",
    },
  };
  handleClose = () => {
    this.setState(
      {
        openAddUsersDialog: false,
        openEmployeeLoginDetailsDialog: false,
        openConfirmationDialog: false,
        selectedRow: {},
        editData: {},
      },
      () => {
        this.getUsersByCompanyId();
      }
    );
  };
  handleOpenAddUsersDialog = () => {
    this.setState({ openAddUsersDialog: true, editData: {} });
  };

  componentDidMount = () => {
    this.getUsersByCompanyId();
  };

  getUsersByCompanyId = () => {
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    authenticationService.getUsers().then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState({
          data: resp.users,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  renderEmployeeLoginDetailsDialog = () => {
    let username = this.state.recentlyAddedUser.employeeNumber
      ? this.state.recentlyAddedUser.employeeNumber
      : this.state.recentlyAddedUser.email;
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Login Details for: ${this.state.recentlyAddedUser.fullName}`}
        messages={[
          `Username (Employee Number): ${
            username ? username : this.state.recentlyAddedUser.fullName
          } `,
          `Password: ${this.state.recentlyAddedUser.password}`,
        ]}
        rightButtonName={"OK"}
        open={this.state.openEmployeeLoginDetailsDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleClose()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  handleOnEditSubmit = (values: any) => {
    const { companyData } = this.props;
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = values;
    userModel.companyId = companyData._id;
    authenticationService.editUser(userModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Edited Successfully",
        });
        this.setState(
          {
            editedUser: userModel,
            openAddUsersDialog: false,
            editData: {},
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };

  handleOnSubmit = (values: any) => {
    const { companyData } = this.props;
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = values;
    userModel.companyId = companyData._id;
    authenticationService.register(userModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "User added Successfully",
        });
        this.setState({
          openAddUsersDialog: false,
          openEmployeeLoginDetailsDialog: true,
          recentlyAddedUser: resp.user,
        });
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };
  deleteAllSelectedEmployees = (selectedList: any) => {
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    authenticationService.deleteAllSelectedUsers(selectedList).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp.success && resp.success === true) {
        if (resp.deleted) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully,partial",
          });
        }
        this.setState(
          {
            openAddUsersDialog: false,
            openConfirmationDialog: false,
            selectedRow: {},
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };
  executeDeleteOnEmployeee = (row: any) => {
    const { companyData } = this.props;
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = row;
    userModel.companyId = companyData._id;
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    authenticationService.deleteUser(userModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openAddUsersDialog: false,
            openConfirmationDialog: false,
            selectedRow: {},
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };

  renderAddUsersDialog = () => {
    return (
      <AddingUsersDialog
        title={"Add User"}
        open={this.state.openAddUsersDialog}
        isAdmin={true}
        handleClose={this.handleClose}
        editData={this.state.editData}
        handleOnSubmit={
          this.state.editData && !isEmpty(this.state.editData)
            ? this.handleOnEditSubmit
            : this.handleOnSubmit
        }
      />
    );
  };
  onEditRow = (row: any) => {
    this.setState({
      editData: row,
      openAddUsersDialog: true,
    });
  };
  onViewRow = (row: any) => {};
  onDeleteRow = (row: any) => {
    this.setState({
      selectedRow: row,
      openConfirmationDialog: true,
    });
  };
  handleConfirmedDelete = () => {
    this.executeDeleteOnEmployeee(this.state.selectedRow);
  };
  renderDeleteConfirmationDialog = () => {
    if (!this.state.selectedRow || !this.state.selectedRow.fullName) {
      return;
    }
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${this.state.selectedRow.fullName}`}
        message={"Are you sure want to delete this user"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  dataActions = (tabType: any, user: any, accessRules: any) => {
    return [
      {
        icon: <EditIcon fontSize="small" />,
        name: tabType,
        action: this.onEditRow,
        visible: HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: "users:edit",
          data: user.role,
        }),
      },
      {
        icon: <DeleteIcon fontSize="small" />,
        name: tabType,
        action: this.onDeleteRow,
        visible: HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: "users:delete",
          data: user.role,
        }),
      },
    ];
  };
  render() {
    const { classes, title, open, handleClose } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <Dialog
              open={open}
              keepMounted={true}
              onClose={() => handleClose()}
              maxWidth={"lg"}
              fullWidth={true}
            >
              <DialogTitle id="alert-dialog-slide-title">
                <Card elevation={0} style={{ width: "100%" }}>
                  <CardHeader
                    action={
                      <HasPermission
                        role={user.role}
                        accessRules={accessRules}
                        perform="users:create"
                        data={user.role}
                        yes={() => (
                          <Fab
                            variant="extended"
                            onClick={() => this.handleOpenAddUsersDialog()}
                          >
                            <AddIcon className={classes.extendedIcon} />
                            {"NEW USER"}
                          </Fab>
                        )}
                        no={() => <div></div>}
                      />
                    }
                    subheader={
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        Logout and Login again after updating the LoggedIn User.
                      </Typography>
                    }
                    title={title}
                  />
                </Card>
              </DialogTitle>
              <Divider />
              <DialogContent>
                {this.state.data && this.state.data.length > 0 && (
                  <TableComponent
                    tableName={"Employees"}
                    columns={ADMINISTRATOR_COLUMNS}
                    data={this.state.data}
                    uniqueIdentifier={createUniqueIdentifier}
                    deleteAllSelected={this.deleteAllSelectedEmployees}
                    createData={createData}
                    deleteAllAction={"users:deleteAll"}
                    company={this.props.companyData}
                    actions={this.dataActions(
                      "ManageUseersDialog",
                      user,
                      accessRules
                    )}
                  />
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    handleClose(this.state.editedUser);
                  }}
                >
                  {"CONTINUE"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </AuthConsumer>
        {this.renderAddUsersDialog()}
        {this.renderEmployeeLoginDetailsDialog()}
        {this.renderDeleteConfirmationDialog()}
      </React.Fragment>
    );
  }
}
ManageUsersDialog.contextType = AppContext;
export default withStyles(styles)(ManageUsersDialog);
